interface ClientNameDisplay {
    ID?: number;
    clientName?: string;
    clientPhone?: string;
}

interface ClientNameItemProps {
    client: ClientNameDisplay;
    onClick?: (clientId: number) => void;
    truncate?: boolean;
}

const ClientNameItem = ({ client, onClick, truncate = false }: ClientNameItemProps) => {
    return (
        <>
            <h6
                className={`mb-1 cursor-pointer ${truncate ? 'text-truncate' : 'text-break'}`}
                title={truncate ? client.clientName : undefined}
                onClick={() => (onClick && client.ID ? onClick(client.ID) : undefined)}
            >
                {client.clientName || '-'}
            </h6>
            <p className="text-muted f-12 mb-0 my-1">{client.clientPhone || '-'}</p>
        </>
    );
};

export default ClientNameItem;
